import React from 'react';
import FormErrors from "./form_errors";
import {_t} from "../../../js/app/common/utils/locale";

export default function render(props) {
    if (!this.state.countries.length) {
        return null;
    }
    return (
        <div className="cluster__form-group">
            <div className="form-group">
                <label className="label" htmlFor={this.props.name}>{_t(this.props.label)}</label>
                <select
                    className={'form-control select ' + (this.props.errors ? 'is-invalid' : '')}
                    id={this.props.name}
                    name={this.props.name}
                    placeholder={_t(this.props.placeholder) || _t(this.props.label)}
                    required={this.props.required ? 'required' : ''}
                    onChange={this.props.onChange}
                    defaultValue={this.props.value}>

                    { this.state.countries.map((item, key) => {
                        return <option key={key} value={item.id}>{item.name}</option>
                    })}

                </select>
                <FormErrors errors={this.props.errors} />
            </div>
        </div>
    );
}